export default __webpack_public_path__ + "static/media/ed-lando.7ea7e578.jpg";